import { ListaDiccionaryEntity } from "./lista_diccionary_entity";

export class VehiculoEntity {
    constructor(
        public Placa?: string,
        public CodVehiculo?: number,
        public CodCliente?: number,
        public CiuCod?: number,
        public CodProducto?: number,
        public CodAseguradora?: number,
        public Poliza?: string,
        public InicioVigencia?: Date,
        public FinVigencia?: Date,
        public ValorAsegurado?: number,
        public TieneCertificado?: number,
        public CodUnidad?: number,
        public Opciones?: ListaDiccionaryEntity[],
        public NombreProducto?: string,
        public NombreVehiculo?: string,
        public NombreAseguradora?: string,
        public Accion?: number,
        public Cancelar?: number,
        public Renovar?: number,
        public EstadoSolicitud?: number,
        public RamCod?: string
    ) {  }
}
export class VehiculoCorporativosEntity {
    constructor(
        public PLACA?: string,
        public BIEN?: string,
        public POLIZA?: string,
        public ASEGURADORA?: string,
        public INICIO?: Date,
        public FIN?: Date,
        public VALOR?: number

    ) {  }
}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/datosGenerales/entities/vehiculo_entity.ts